<template>
  <obj-page-container
    class="c-cbr-HeaderPadding"
    data-scroll-to="container-return-select"
  >
    <template>
      <div class="o-flex c-cbr-ReturnPlan-wrapper">
        <!-- GB, CH and the Baltics have a individual parcel shop finder logic-->
        <cbr-return-plan
          v-if="!['GB','CH', 'EE', 'LT', 'LV'].includes(formDataCountry)"
          :sub-headline="$t('return.free')"
          headline="return.parcel_shop"
          val="parcel_shop"
          @selected="setReturnPlan('drop_shop')"
        >
          <div slot="content">
            <div v-if="!dropShops">
              <div :class="[$style['no-results'], $style['box']]">

                <img
                  src="/assets/pin.svg"
                  style="height: 15px; width: 20px"
                >
                <obj-link
                  :href="getCountrySpecificUrl(formDataCountry) + '?search-gls-points-address=' + formDataCity +' ' + formDataPostalCode"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ $t('return.show_more') }}
                </obj-link>
              </div>
              <p :class="$style.sorryMsg">
                {{ $t('return.no_parcelshop_nearby_main') }}
              </p>
            </div>

            <div v-else-if="dropShops.length === 0">
              <obj-spinner />
            </div>

            <div v-else>
              <div
                style="margin-top: 0.5em; margin-bottom: 0.5em; display: flex"
              >
                <span style="flex: 1">{{
                  $t('return.next_parcel_shops')
                }}</span>
                <span>
                  <obj-link
                    :href="getCountrySpecificUrl(formDataCountry) + '?search-gls-points-address=' + formDataCity +' ' + formDataPostalCode"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {{ $t('return.show_more') }}
                  </obj-link>
                </span>
              </div>

              <cbr-drop-shop :drop-shop="selectedDropShop" />

              <div :class="['o-text', 'is-centered']">
                {{ $t('return.not_tied_to_gls_shop_notice') }}
              </div>
            </div>
          </div>
        </cbr-return-plan>

        <!-- For GB the Parcelforce Website is used to find drop-off points-->
        <cbr-return-plan
          v-if="formDataCountry === 'GB'"
          :sub-headline="$t('return.free')"
          headline="return.uk_parcel_shop"
          val="parcel_shop"
          @selected="setReturnPlan('drop_shop')"
        >
          <div slot="content">
            <div>
              <div :class="[$style['no-results'], $style['box']]">
                <p :class="$style.sorryMsg">
                  {{ $t('return.uk_external_shops_line_1') }}
                  <span :class="[$style['br']]" />
                  {{ $t('return.uk_external_shops_line_2') }}

                  <!-- HACK Create a reusable template for this -->

                  <img
                    src="/assets/pin.svg"
                    style="height: 15px; width: 20px"
                  >

                  <obj-link
                    :href="getCountrySpecificUrl(formDataCountry) + '?search_location=' + formDataPostalCode + '&service_code=0'"
                    target="_blank"
                  >
                    {{ $t('return.uk_external_shops_link') }}</obj-link
                    >
                </p>
              </div>

              <div style="text-align: center">
                <span :class="$style.hint">
                  {{ $t('return.uk_return_hint_line_1') }}</span
                  >
                <span
                  v-html="
                    $t('return.uk_return_hint_line_2', {
                      customer: brandName,
                      interpolation: false,
                    })
                  "
                />
              </div>

              <p :class="$style.sorryMsg">
                {{ $t('return.uk_return_instruction') }}
              </p>
            </div>
          </div>
        </cbr-return-plan>

        <!-- EE / LV / LT - The Baltics have a specific hint instead of a parcel shop finder feature -->
        <cbr-return-plan
          v-if="formDataCountry === 'EE' || formDataCountry === 'LT' || formDataCountry === 'LV'"
          :sub-headline="$t('return.free')"
          headline="return.ee_lt_lv_parcel_shop"
          val="parcel_shop"
          @selected="setReturnPlan('drop_shop')"
        >
          <div slot="content">
            <div>
              <div style="text-align: center">
                <span v-html="$t('return.ee_lt_lv_hint')" />
              </div>
            </div>
          </div>
        </cbr-return-plan>

        <!-- For CH the Swiss Post Website is used to find drop-off points -->
        <cbr-return-plan
          v-if="formDataCountry === 'CH'"
          :sub-headline="$t('return.free')"
          headline="return.ch_parcel_shop"
          val="parcel_shop"
          @selected="setReturnPlan('drop_shop')"
        >
          <div slot="content">
            <div>
              <div :class="[$style['no-results'], $style['box']]">
                <p :class="$style.sorryMsg">
                  {{ $t('return.ch_external_shops_line_1') }}
                  <span :class="[$style['br']]" />
                  {{ $t('return.ch_external_shops_line_2') }}

                  <!-- HACK Create a reusable template for this -->

                  <img
                    src="/assets/pin.svg"
                    style="height: 15px; width: 20px"
                  >

                  <obj-link
                    :href="getCountrySpecificUrl(formDataCountry)"
                    target="_blank"
                  >
                    {{ $t('return.ch_external_shops_link') }}</obj-link
                    >
                </p>
              </div>
              <p :class="$style.sorryMsg">
                {{ $t('return.ch_return_instruction') }}
              </p>
            </div>
          </div>
        </cbr-return-plan>
      </div>
    </template>

    <cbr-map
      :show="showMap"
      :markers="markers"
      @close="showMap = false" />
  </obj-page-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import CbrReturnPlan from '../components/CbrReturnPlan.vue'
import ObjLink from '../components/ObjLink.vue'
import ObjPageContainer from '../components/ObjPageContainer.vue'
import CbrDropShop from '../components/CbrDropShop.vue'
import CbrMap from '../components/CbrMap.vue'
import ObjSpinner from '../components/ObjSpinner.vue'
import { getCountrySpecificUrl } from '../../static/parcelshopSearchURLs'

export default {
  components: {
    CbrReturnPlan,
    ObjLink,
    ObjPageContainer,
    CbrDropShop,
    CbrMap,
    ObjSpinner,
  },
  data() {
    return {
      showMap: false,
    }
  },
  computed: {
    ...mapState('dropShops', ['dropShops', 'markers']),
    ...mapGetters('dropShops', ['selectedDropShop']),
    ...mapGetters('inputData', [
      'formIsValid',
      'formDataCountry',
      'formDataCity',
      'formDataPostalCode',
    ]),
    ...mapGetters('config', ['brandName']),

    currentLanguage: {
      get: function () {
        return this.$store.state.lang.currentLanguage
      },
      set: function (val) {
        this.languageSelect(val)
      },
    },
  },
  methods: {
    getCountrySpecificUrl(formDataCountry) {
      return getCountrySpecificUrl(formDataCountry)
    }
  }
}
</script>

<style module>
.no-results {
  text-align: center;
}

.box {
  margin-top: 0.5em;
  margin-bottom: 1.5em;
}

.br {
  text-align: center;
  display: block;
  margin-bottom: 0.25em;
}

.sorryMsg {
  text-align: center;
  margin-bottom: 0px;
}

.hint {
  color: rgb(107, 21, 68);
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// client/components/CbrChooseReturnMethod.vue